import { render, staticRenderFns } from "./Proveedores.vue?vue&type=template&id=757712ab&scoped=true"
import script from "./Proveedores.vue?vue&type=script&lang=js"
export * from "./Proveedores.vue?vue&type=script&lang=js"
import style0 from "./Proveedores.vue?vue&type=style&index=0&id=757712ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757712ab",
  null
  
)

export default component.exports